import styled from '@emotion/styled';

import { screen } from '@/components/common/breakpoints';
import { RichHeading } from '@/components/common/Heading';
import { Heading, HeadingLevel, Paragraph } from '@/components/common/MarkUp';
import { PortableText } from '@/components/common/utils';
import { Section } from '@/components/layout/Section';

import type { SanityChecklistType } from '@/types/sanity';

export interface ChecklistProps extends SanityChecklistType {}

export const Checklist = ({ heading, steps, description }: ChecklistProps) => {
  return (
    <Section backgroundColour="--background-subtle">
      <HeadingLevel>
        <ChecklistWrapper>
          <HeadingWrapper>
            <RichHeading heading={heading} size="headline-md" />
          </HeadingWrapper>
          <SubHeadingWrapper>
            <PortableText value={description} />
          </SubHeadingWrapper>
          <HeadingLevel>
            {steps.map((step) => (
              <Step key={step._key}>
                <Heading size="headline-md">
                  <b>{step.title}</b>
                </Heading>
                <Paragraph size="body-md">{step.description}</Paragraph>
              </Step>
            ))}
          </HeadingLevel>
        </ChecklistWrapper>
      </HeadingLevel>
    </Section>
  );
};

const ChecklistWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: auto;

  ${screen.md} {
    width: 839px;
  }
`;

const SubHeadingWrapper = styled.div`
  text-align: center;
  padding: var(--spacing-300) 0 var(--spacing-400) 0;
  p:first-of-type {
    padding-bottom: var(--spacing-medium);
  }
`;

const HeadingWrapper = styled.div`
  max-width: 630px;
  text-align: center;
  padding: var(--spacing-500) 0;
`;

const Step = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: var(--radius-s);
  width: 100%;
  min-height: 256px;
  padding: var(--spacing-large);
  margin-bottom: var(--spacing-medium);

  ${Heading} {
    margin-bottom: var(--spacing-300);
    padding-bottom: var(--spacing-300);
    font-size: var(--font-size-small);
  }
`;
